import cn from 'classnames';
import type { ComponentProps } from 'react';
import { BaseDatePicker, type DatePickerDateType, useGetDatePickerFormat, useIsTwelveHourFormat } from '../base-picker';
import styles from './date-picker.module.css';

export type DatePickerProperties<ValueType = DatePickerDateType, IsMultiple extends boolean = false> = {
  fullWidth?: boolean;
} & ComponentProps<typeof BaseDatePicker<ValueType, IsMultiple>>;

const DatePicker = <ValueType = DatePickerDateType, IsMultiple extends boolean = false>({
  className,
  fullWidth,
  showTime,
  ...props
}: DatePickerProperties<ValueType, IsMultiple>) => {
  const getDatePickerFormat = useGetDatePickerFormat();
  const isTwelveHourFormat = useIsTwelveHourFormat();

  return (
    <BaseDatePicker<ValueType, IsMultiple>
      className={cn(className, { [styles['full-width'] ?? '']: fullWidth })}
      format={showTime ? getDatePickerFormat('defaultDateTimeFormat') : getDatePickerFormat('defaultDateFormat')}
      showTime={
        showTime
          ? {
              format: getDatePickerFormat('defaultTimeFormat'),
              showSecond: false,
              use12Hours: isTwelveHourFormat,
              ...(typeof showTime === 'object' ? showTime : {}),
            }
          : undefined
      }
      size="large"
      {...props}
    />
  );
};

export default DatePicker;
